
import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ConfirmPurchase extends Vue{
maxPoint='';

created(){
  axios.get('/mypage/confirm-purchase/max-point')
  .then((val) => {
    this.maxPoint = val.data.toLocaleString("ko-KR")
    })
}
}
